import React, { useState } from 'react'
import algoliasearch from 'algoliasearch/lite';
import { RelatedProducts } from '@algolia/recommend-react';
import recommend from '@algolia/recommend';
import { useNavigate, useParams } from 'react-router-dom';
import { Button, Card, CardContent, Typography, useMediaQuery } from '@mui/material';
import { Image } from 'cloudinary-react';
import { AddShoppingCart } from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';
import './algolia.css'
import "react-multi-carousel/lib/styles.css";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Scrollbar, Autoplay } from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/navigation';
import 'swiper/css/autoplay';

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
    slidesToSlide: 3 // optional, default to 1.
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
    slidesToSlide: 2 // optional, default to 1.
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
    slidesToSlide: 1 // optional, default to 1.
  }
};


const RelatedProductsSlider = ({handleAddToCart}) => {

const indexName = 'products';
const client = algoliasearch("EXZ7Q11Q58", "812cfff2beb8916035b22c33e01a4c3e");
const index = client.initIndex(indexName);
const recommendClient = recommend("EXZ7Q11Q58", "812cfff2beb8916035b22c33e01a4c3e");
const theme = useTheme()
const isXs= useMediaQuery(theme.breakpoints.down('xs'));
const isSm= useMediaQuery(theme.breakpoints.down('sm'));
const isMd= useMediaQuery(theme.breakpoints.down('md'));
const isLg= useMediaQuery(theme.breakpoints.down('lg'));
const isXl= useMediaQuery(theme.breakpoints.down('xl'));
const params = useParams();
const productID =  params.id

const [count, setCount] = useState([])
const navigate = useNavigate()

function RelatedItem({ item }) {
  console.log("item is", item)
  return (
    <div
      style={{ height: '500px', width: '350px', margin: '0 auto', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
        <Card style={{padding: '30px', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection:'column'}}>
         <div onClick={() => {
          if(item.title.includes("Case")) {
            navigate(`/phonecase/${item.objectID}`)
          }else if(item.title.includes("Headphones")) {
            navigate(`/headphone/${item.objectID}`) 
          } else if(item.title.includes("Charger")) {
            navigate(`/charger/${item.objectID}`)
          } else {
            navigate(`/smartphone/${item.objectID}`)
          }
        }}>
          <div style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
          <Image className="pointer" cloudName="deqqgmfxk"  publicId={item.img} style={{width: '150px', height: '150px', objectFit:'cover', objectPosition:'center center'}}/>
          </div>
        <CardContent style={{textAlign: 'center'}} >
            <div className="pointer">
              <Typography gutterBottom variant="h6" component="h2"
              >
                {item.title}
              </Typography>
              <Typography gutterBottom variant="subtitle1" component="h2">
                Price: ${item.price}
              </Typography>
            </div>
          </CardContent>
          </div>
          <div className="btns">
            <Button variant="contained" onClick={() => handleAddToCart(item)} startIcon={<AddShoppingCart />} size="small" color="secondary" id="submitBtn" type="submit">
              Cart
            </Button>
          </div>
        </Card>
      </div>
  );
}

const CustomRightArrow = () => (
  <div style={{backgroundColor:'red', height:'300px', width:'300px'}}>
    RIGHT
  </div>
)

const CustomLeftArrow = () => (
  <div style={{backgroundColor:'red', height:'300px', width:'300px'}}>
    LEFT
  </div>
)

  return (
    <Swiper
    modules={[Navigation, Pagination, Scrollbar, Autoplay]}
    spaceBetween={50}
    slidesPerView={1}
    onSlideChange={() => console.log('slide change')}
    onSwiper={(swiper) => console.log(swiper)}
    pagination={{ clickable: true }}
    navigation={true}
    autoplay={{delay: 4000}}
    id="swiperContainerMobile"
    >
    <SwiperSlide>
      <RelatedProducts
          style={{display:'flex', justifyContent:'space-between', alignItems:'center'}}
          recommendClient={recommendClient}
          indexName={indexName}
          objectIDs={[productID]}
          itemComponent={RelatedItem}
          maxRecommendations={3}
      />
    </SwiperSlide>
    </Swiper>

  )
}

export default RelatedProductsSlider